import React from 'react';

/**
 * Skip navigation link — visible on keyboard focus (WCAG 2.4.1 Bypass Blocks).
 * Programmatically moves focus to the target so screen readers announce main content.
 */
export function SkipLink({ targetId = 'main-content', children = 'Skip to main content' }) {
  const handleClick = (event) => {
    event.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus({ preventScroll: false });
    }
  };

  return (
    <a href={`#${targetId}`} className="skip-link" onClick={handleClick}>
      {children}
    </a>
  );
}

export default SkipLink;
